<template>
    <div class="left_panel add_player">
        <div class="row checkout_wizard">
            <div class="col-lg-12">
                <h2 class="font_size_20 font-weight-bold mb-0 text_black">
                    Add New player
                </h2>
            </div>
        </div>
        <form
            method="post"
            @submit.prevent="addPlayer()"
            data-vv-scope="addplayerform"
        >
            <div class="row">
                <div class="col-md-12 accordian_with_form">
                    <div class="accordion mt_30" id="accordionExample">
                        <div class="card">
                            <div class="card-header p-0" id="headingOne">
                                <h2
                                    class="mb-0 accordian_heading text-left d-flex"
                                    style="
                                        font-weight: normal !important;
                                        font-family: proximaNova-regular !important;
                                        color: #0079c1 !important;
                                    "
                                >
                                    Details
                                </h2>
                            </div>

                            <div
                                id="collapseOne"
                                class="collapse show"
                                aria-labelledby="headingOne"
                                data-parent="#accordionExample"
                            >
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group mobile_pr_0">
                                                <input
                                                    type="text"
                                                    id="first_name"
                                                    name="first_name"
                                                    v-validate="'required'"
                                                    placeholder="Enter First Name"
                                                    v-model="
                                                        player_data.first_name
                                                    "
                                                    data-vv-as="First Name"
                                                    class="form-control bg-transparent"
                                                />
                                                <label>Player First Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.first_name'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.first_name"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group w-100">
                                                <input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    v-validate="'required'"
                                                    placeholder="Enter Last Name"
                                                    v-model="
                                                        player_data.last_name
                                                    "
                                                    data-vv-as="Last Name"
                                                    class="form-control bg-transparent"
                                                />
                                                <label>Player Last Name</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.last_name'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.last_name"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_50">
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="mobile"
                                                    name="mobile"
                                                    v-validate="
                                                        'required|min:12'
                                                    "
                                                    placeholder="+1 789-632-1452"
                                                    v-model="player_data.mobile"
                                                    data-vv-as="Mobile"
                                                    @input="acceptNumber"
                                                    class="form-control bg-transparent"
                                                />
                                                <label>Mobile</label>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.mobile'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.mobile"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-lg-6">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    v-validate="
                                                        'required|email'
                                                    "
                                                    placeholder="Enter Email"
                                                    v-model="player_data.email"
                                                    data-vv-as="Email"
                                                    :disabled="player_data.id"
                                                    class="form-control bg-transparent"
                                                />
                                                <label>Email</label>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.email'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.email"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_50">
                                        <div class="col-md-12 col-lg-6">
                                            <div
                                                class="form-group add_new_player_state_box"
                                            >
                                                <label>State</label>
                                                <span class="highlight"></span>
                                                <v-select
                                                    autocomplete="off"
                                                    label="code"
                                                    :reduce="
                                                        (name) => name.code
                                                    "
                                                    :options="all_states"
                                                    :placeholder="'Select State'"
                                                    name="state"
                                                    v-model="player_data.state"
                                                    v-validate="'required'"
                                                    data-vv-as="State"
                                                ></v-select>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.state'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.state"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-6 d-flex align-items-start justify-content-between"
                                        >
                                            <div class="form-group w-50 pr_44">
                                                <label>City</label
                                                ><span class="highlight"></span>
                                                <input
                                                    type="text"
                                                    class="form-control bg-transparent"
                                                    id="city"
                                                    name="city"
                                                    v-model="player_data.city"
                                                    v-validate="'required'"
                                                />
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.city'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.city"
                                                        )
                                                    }}
                                                </small>
                                            </div>

                                            <div
                                                class="form-group w-50 mobile_margin_top"
                                            >
                                                <input
                                                    type="text"
                                                    id="zipcode"
                                                    name="zipcode"
                                                    v-validate="
                                                        'required|numeric|min:4|max:6'
                                                    "
                                                    placeholder="Enter Zipcode"
                                                    v-model="
                                                        player_data.zipcode
                                                    "
                                                    data-vv-as="Zip Code"
                                                    class="form-control bg-transparent"
                                                /><label
                                                    >Zip / Postal code</label
                                                ><span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'addplayerform.zipcode'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "addplayerform.zipcode"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                            <input
                                                type="hidden"
                                                v-model="player_data.id"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="containt_loader" v-show="isLoader">
                                <div class="preloader-body">
                                    <svg
                                        width="40"
                                        height="40"
                                        viewBox="0 0 40 40"
                                    >
                                        <polygon
                                            class="rect"
                                            points="0 0 0 40 40 40 40 0"
                                        ></polygon>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="buttons edit_profile_btn mt_52 ml-auto text-right"
                    >
                        <router-link :to="{ name: 'ManagePlayer' }">
                            <a
                                href="javascript:void(0)"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                            >
                                Cancel
                            </a>
                        </router-link>
                        <button
                            type="submit"
                            class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                            v-if="buttonUpdate == true"
                        >
                            Update Player
                        </button>
                        <button
                            type="submit"
                            class="btn btn-primarybtn btn_orange bg_primary_orange text_white py_18 px_52"
                            v-else
                        >
                            Add Player
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";

export default {
    name: "AddNewPlayer",
    components: {},
    data() {
        return {
            buttonUpdate: false,
            player_data: {
                role_id: 4
            },
            all_states: [],
            isLoader: false
        };
    },
    mounted() {
        document.body.classList.add("bg_primary_light_white");
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
        if (this.$route.params.id != undefined) {
            this.buttonUpdate = true;
            this.isLoader = false;
            this.getSinglePlayer(this.$route.params.id);
        }
        this.getStates();
    },
    methods: {
        addPlayer() {
            var _this = this;
            _this.$validator.validateAll("addplayerform").then((isValid) => {
                if (isValid) {
                    _this.isLoader = true;
                    new Promise((resolve) => {
                        if (this.$route.params.id != undefined) {
                            ApiService.put("/players", _this.player_data)
                                .then(({ data }) => {
                                    resolve(data);
                                    _this.isLoader = false;
                                    _this.$toast.success(
                                        "Player updated successfully",
                                        {
                                            position: "top-right"
                                        }
                                    );
                                    _this.$router.push({
                                        name: "ManagePlayer"
                                    });
                                })
                                .catch(({ response }) => {
                                    /* eslint-disable */
                                    context.commit(SET_ERROR, response.data.errors);
                                    /* eslint-enable */
                                });
                        } else {
                            ApiService.post("/players", _this.player_data)
                                .then(({ data }) => {
                                    if (data.success) {
                                        _this.isLoader = false;
                                        _this.$toast.success(
                                            "Player added successfully",
                                            {
                                                position: "top-right"
                                            }
                                        );
                                        _this.$router.push({
                                            name: "ManagePlayer"
                                        });
                                    }
                                })
                                .catch(({ response }) => {
                                    _this.$toast.error(response.data.error, {
                                        position: "top-right"
                                    });
                                });
                        }
                    });
                }
            });
        },
        acceptNumber() {
            var x = this.player_data.mobile
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.player_data.mobile = !x[2]
                ? x[1]
                : "" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        },
        getSinglePlayer(id) {
            var _this = this;
            new Promise(() => {
                ApiService.get("/players/" + id)
                    .then(({ data }) => {
                        _this.isLoader = false;
                        _this.player_data = {
                            id: data.player.id,
                            first_name: data.player.first_name,
                            last_name: data.player.last_name,
                            mobile: data.player.mobile,
                            email: data.player.email,
                            state: data.player.Profile.state,
                            city: data.player.Profile.city,
                            zipcode: data.player.Profile.zipcode
                        };
                    })
                    .catch((response) => {
                        console.log(response);
                    });
            });
        },
        getStates() {
            var _this = this;
            new Promise(() => {
                ApiService.get("/states")
                    .then(({ data }) => {
                        _this.all_states = data.states;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                    });
            });
        }
    }
};
</script>
